var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9687 16.9637C99.5464 24.2276 97.6523 31.8077 91.9661 37.1782C85.6471 43.4971 76.4889 45.0748 68.592 42.2317L61.6444 48.863L56.9072 44.1258L52.17 48.863L44.9061 41.2827L56.2781 29.9107C53.1186 22.014 55.0127 12.8558 61.3317 6.53662C66.7016 0.850399 74.2814 -1.04367 81.5461 0.53402L69.5451 12.2184L73.3374 25.1681L86.2871 28.644L97.9715 16.9596L97.9687 16.9637ZM0.369363 11.2775L5.10655 6.22392L17.7407 14.437L15.8466 16.6474L52.1704 52.9712L56.9076 48.5504L61.3284 52.9712L59.7507 54.5489C57.224 57.0756 60.3834 61.1802 63.543 57.7084L92.9196 87.085C94.4973 88.6627 94.185 91.1895 92.6033 92.7713L86.6007 98.7739C85.023 100.352 82.4962 100.352 80.9144 99.0902L51.8544 69.7136C55.0139 66.5541 50.9053 63.3946 48.3785 65.9213L46.8008 67.499L42.38 62.7618L47.1172 58.341L10.4768 21.7007L8.58275 23.5947L0.369363 11.2775ZM43.0081 67.8157L14.8968 95.6105C6.68371 103.824 -5.3177 91.5061 2.57919 83.6095L35.4268 50.7619L42.6907 58.3422L37.9535 62.763L43.0081 67.8157ZM13.3191 85.1872C14.8968 86.4526 14.8968 88.6631 13.3191 90.2408C12.0537 91.5062 9.8432 91.5062 8.26551 90.2408C7.00009 88.6631 7.00009 86.4485 8.26551 85.1872C9.8432 83.6095 12.0578 83.6095 13.3191 85.1872Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdk);
export default __webpack_public_path__ + "static/media/sdk.4379f39b05c3934846b8ec6a55cbbc8a.svg";
export { ForwardRef as ReactComponent };